import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule,IonicPageModule } from 'ionic-angular';
import { AdminDashboardPage } from './admin-dashboard';
import { BrokerSettingPage } from '../../pages/broker_setting/broker_setting';
import { AdfList } from '../../pages/adf-list/adf-list';
import { EditPopoverPage } from '../../pages/edit-popover/edit-popover';
import { CommonModule } from "@angular/common";
import {ProgressBarModule} from "angular-progress-bar"

import { HttpModule } from '@angular/http';
import { SelectSearchableModule } from 'ionic-select-searchable';
import { HomePage } from '../../pages/home/home';
import { LoginPage } from '../../pages/login/login';
import { LoadingProvider } from '../../providers/loading/loading';
import { HttpClientModule } from '@angular/common/http';
import { IonicStepperModule } from 'ionic-stepper';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { BrMaskerModule } from 'br-mask';
import { SearchPage } from '../../pages/search/search';
import { ThankyouPage } from '../../pages/thankyou/thankyou';
import { ViewContactPage } from '../../pages/view-contact/view-contact';
import { InputMaskModule } from 'ionic-input-mask';
import { TextMaskModule } from 'angular2-text-mask';
import { BrokersPage } from '../../pages/brokers/brokers';
import { CreateBrokerPage } from '../../pages/create-broker/create-broker';
import { ViewBrokerPage } from '../../pages/view-broker/view-broker';
import { AddContactPage } from '../../pages/add-contact/add-contact';
import { ViewContactPdfPage } from '../../pages/view-contact-pdf/view-contact-pdf';
import { TentativeRealEstateAssetPage } from '../../pages/tentative-real-estate-asset/tentative-real-estate-asset';
import { IonicStorageModule } from '@ionic/storage';
import { DisallowAccessPage } from '../../pages/disallow-access/disallow-access';
import { UserData } from '../../providers/loading/userData';
import { ChangeAssignedBrokerPage } from '../../pages/change-assigned-broker/change-assigned-broker';
import { ApiCredentialsPage } from '../../pages/api-credentials/api-credentials';
import {AcSettingsPage} from '../../pages/ac-settings/ac-settings';
import { AllowCustomerPermissionPage } from '../../pages/allow-customer-permission/allow-customer-permission';
import { LoanAdminPage } from '../../pages/loan-admin/loan-admin';
import { AddLoanAdminPage } from '../../pages/add-loan-admin/add-loan-admin';
import { EditContactPage } from '../../pages/edit-contact/edit-contact';
import { AgmCoreModule } from '@agm/core';
import { FormsModule } from '@angular/forms';
import { DeletedRecordsPage } from '../../pages/deleted-records/deleted-records';
import { ChangeLogPage } from '../../pages/change-log/change-log';
import { ViewChangeLogPage } from '../../pages/view-change-log/view-change-log';
import { ChangeLogProfilePage } from '../../pages/change-log-profile/change-log-profile';
import { AttachmentRequestsPage } from '../../pages/attachment-requests/attachment-requests';
import { SubmitAttachmentsPage } from '../../pages/submit-attachments/submit-attachments';
import { AngularFireStorageModule } from 'angularfire2/storage';
import { HistoryDetailsPage } from '../../pages/history-details/history-details';
import { ChangeContactTypePopupPage } from '../../pages/change-contact-type-popup/change-contact-type-popup';
import { SdfFormService } from '../../app/services/sdf-form-service';
import { HomeService } from '../../app/services/home-service';
import { ChangeAssignedBrokerService } from '../../app/services/change-assigned-brokerService';
import { TentativeRealEstateService } from '../../app/services/tentative-real-estate-service';
import { ViewMoreAddressPage } from '../../pages/view-more-address/view-more-address';
import { OwnUserListPage } from '../../pages/own-user-list/own-user-list';
import RealEstatePage from '../../pages/real-estate/real-estate';
import { EnvDataService } from '../../app/services/env-data-service';
import { AdfPageModule } from '../../pages/adf-page/adf-page.module';
import { Stepper } from '../../pages/adf-page/component/stepper/stepper';
import { ContactList } from '../../pages/contact-list/contact_list';
import { EditContactModule } from '../../pages/edit-contact-form-list/edit-contact-from-list.module';
import { ShowContactForm } from '../../pages/show-contact/show-contact';
import { ShowContactPdfPage } from '../../pages/show-contact-pdf/show-contact-pdf';
import { AllowCustomerContactPermissionPage } from '../../pages/allow-customer-contact-permission/allow-customer-contact-permission';
import { ViewAdfPage } from '../../pages/view-adf/view-adf';
import { AdfListService } from '../../pages/adf-page/services/adf-list.service';
import { AdfCustomerPermissionPage } from '../../pages/adf-customer-permission/adf-customer-permission';
import { AdfCustomerExistPage } from '../../pages/adf-customer-exist/adf-customer-exist';
// import {ViewDealPage} from '../pages/view-deal/view-deals';
// import {TimeAgoPipe} from 'time-ago-pipe';
// import {CustomerDashboardPage} from '../pages/customers/customer-dashboard/customer-dashboard';
// import {SidebarComponent} from '../components/sidebar/sidebar';
//  import {PersonaldetailsComponent} from '../components/personaldetails/personaldetails';
// import {HeaderComponent} from '../components/header/header';
// import {PersonalDetailsPage} from '../pages/personal-details/personal-details';
import {BrokerpagepopComponent} from '../../components/brokerpagepop/brokerpagepop';
@NgModule({
  declarations: [
    AdminDashboardPage,
    HomePage,
    LoginPage,
    SearchPage,
    ThankyouPage,
    ViewContactPage,
    ViewAdfPage,
    BrokersPage,
    CreateBrokerPage,
    ViewBrokerPage,
    AddContactPage,
    EditPopoverPage,
    ViewContactPdfPage,
    RealEstatePage,
    TentativeRealEstateAssetPage,
    DisallowAccessPage,
    ChangeAssignedBrokerPage,
    ApiCredentialsPage,
    AcSettingsPage,
    AllowCustomerPermissionPage,
    AdfCustomerPermissionPage,
    AllowCustomerContactPermissionPage,
    AdfCustomerExistPage,
    LoanAdminPage,
    AddLoanAdminPage,
    EditContactPage,
    DeletedRecordsPage,
    ChangeLogPage,
    ViewChangeLogPage,
    ChangeLogProfilePage,
    AttachmentRequestsPage,
    SubmitAttachmentsPage,
    HistoryDetailsPage,
    ChangeContactTypePopupPage,
    ViewMoreAddressPage,
    OwnUserListPage,
    ContactList,
    ShowContactForm,
    ShowContactPdfPage,
    AdfList,
    BrokerSettingPage,
    BrokerpagepopComponent
  ],
  imports: [
    CommonModule,
    ProgressBarModule,
    BrMaskerModule,
    IonicStepperModule,
    FormsModule,
    IonicStorageModule.forRoot(),
    HttpClientModule,
    SelectSearchableModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    HttpModule,
    InputMaskModule,
    TextMaskModule,
    AdfPageModule,
    EditContactModule,
    IonicPageModule.forChild(AdminDashboardPage),
  ],
  entryComponents: [
    HomePage,
    LoginPage,
    SearchPage,
    ThankyouPage,
    ViewContactPage,
    ViewAdfPage,
    BrokersPage,
    CreateBrokerPage,
    ViewBrokerPage,
    AddContactPage,
    EditPopoverPage,
    ViewContactPdfPage,
    RealEstatePage,
    TentativeRealEstateAssetPage,
    DisallowAccessPage,
    ChangeAssignedBrokerPage,
    ApiCredentialsPage,
    AcSettingsPage,
    AllowCustomerPermissionPage,
    AdfCustomerPermissionPage,
    AdfCustomerExistPage,
    AllowCustomerContactPermissionPage,
    LoanAdminPage,
    AddLoanAdminPage,
    EditContactPage,
    DeletedRecordsPage,
    ChangeLogPage,
    ViewChangeLogPage,
    ChangeLogProfilePage,
    AttachmentRequestsPage,
    SubmitAttachmentsPage,
    HistoryDetailsPage,
    ChangeContactTypePopupPage,
    ViewMoreAddressPage,
    OwnUserListPage,
    ContactList,
    ShowContactForm,
    ShowContactPdfPage,
    AdfList,
    BrokerSettingPage,
    BrokerpagepopComponent
  ],

  providers: [
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    LoadingProvider,
    Storage,
    UserData,
    SdfFormService,
    HomeService,
    ChangeAssignedBrokerService,
    TentativeRealEstateService,
    EnvDataService,
    AdfListService
  ]
})
export class AdminDashboardPageModule {}



// WEBPACK FOOTER //
// ./src/pages/admin-dashboard/admin-dashboard.module.ts